module.exports = __webpack_public_path__ + "img/nocamera-tips.d6d10cd6.png";